export const LIST_OF_STATES = [
  { label: 'Alabama', value: 'AL', abbreviation: 'AL' },
  { label: 'Alaska', value: 'AK', abbreviation: 'AK' },
  { label: 'Arizona', value: 'AZ', abbreviation: 'AZ' },
  { label: 'Arkansas', value: 'AR', abbreviation: 'AR' },
  { label: 'California', value: 'CA', abbreviation: 'CA' },
  { label: 'Colorado', value: 'CO', abbreviation: 'CO' },
  { label: 'Connecticut', value: 'CT', abbreviation: 'CT' },
  { label: 'Delaware', value: 'DE', abbreviation: 'DE' },
  { label: 'District Of Columbia', value: 'DC', abbreviation: 'DC' },
  { label: 'Florida', value: 'FL', abbreviation: 'FL' },
  { label: 'Foreign', value: 'FG', abbreviation: 'FG' },
  { label: 'Georgia', value: 'GA', abbreviation: 'GA' },
  { label: 'Hawaii', value: 'HI', abbreviation: 'HI' },
  { label: 'Idaho', value: 'ID', abbreviation: 'ID' },
  { label: 'Illinois', value: 'IL', abbreviation: 'IL' },
  { label: 'Indiana', value: 'IN', abbreviation: 'IN' },
  { label: 'Iowa', value: 'IA', abbreviation: 'IA' },
  { label: 'Kansas', value: 'KS', abbreviation: 'KS' },
  { label: 'Kentucky', value: 'KY', abbreviation: 'KY' },
  { label: 'Louisiana', value: 'LA', abbreviation: 'LA' },
  { label: 'Maine', value: 'ME', abbreviation: 'ME' },
  { label: 'Maryland', value: 'MD', abbreviation: 'MD' },
  { label: 'Massachusetts', value: 'MA', abbreviation: 'MA' },
  { label: 'Michigan', value: 'MI', abbreviation: 'MI' },
  { label: 'Minnesota', value: 'MN', abbreviation: 'MN' },
  { label: 'Mississippi', value: 'MS', abbreviation: 'MS' },
  { label: 'Missouri', value: 'MO', abbreviation: 'MO' },
  { label: 'Montana', value: 'MT', abbreviation: 'MT' },
  { label: 'Nebraska', value: 'NE', abbreviation: 'NE' },
  { label: 'Nevada', value: 'NV', abbreviation: 'NV' },
  { label: 'New Hampshire', value: 'NH', abbreviation: 'NH' },
  { label: 'New Jersey', value: 'NJ', abbreviation: 'NJ' },
  { label: 'New Mexico', value: 'NM', abbreviation: 'NM' },
  { label: 'New York', value: 'NY', abbreviation: 'NY' },
  { label: 'North Carolina', value: 'NC', abbreviation: 'NC' },
  { label: 'North Dakota', value: 'ND', abbreviation: 'ND' },
  { label: 'Ohio', value: 'OH', abbreviation: 'OH' },
  { label: 'Oklahoma', value: 'OK', abbreviation: 'OK' },
  { label: 'Oregon', value: 'OR', abbreviation: 'OR' },
  { label: 'Pennsylvania', value: 'PA', abbreviation: 'PA' },
  { label: 'Rhode Island', value: 'RI', abbreviation: 'RI' },
  { label: 'South Carolina', value: 'SC', abbreviation: 'SC' },
  { label: 'South Dakota', value: 'SD', abbreviation: 'SD' },
  { label: 'Tennessee', value: 'TN', abbreviation: 'TN' },
  { label: 'Texas', value: 'TX', abbreviation: 'TX' },
  { label: 'Utah', value: 'UT', abbreviation: 'UT' },
  { label: 'Vermont', value: 'VT', abbreviation: 'VT' },
  { label: 'Virginia', value: 'VA', abbreviation: 'VA' },
  { label: 'Washington', value: 'WA', abbreviation: 'WA' },
  { label: 'West Virginia', value: 'WV', abbreviation: 'WV' },
  { label: 'Wisconsin', value: 'WI', abbreviation: 'WI' },
  { label: 'Wyoming', value: 'WY', abbreviation: 'WY' }
]
